import React, {Component} from 'react'
import firebase from "../../../Config/firebase";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBAlert,
    MDBTabContent,
    MDBNav,
    MDBNavItem,
    MDBNavLink,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBListGroup,
    MDBListGroupItem,
    MDBBadge
} from "mdbreact";
import {Link, withRouter} from "react-router-dom";
import classes from './Profile.module.css'
import {isAuth} from "../../../Utils/firebaseUtils";
import {connect} from "react-redux";
import {isValidEmail, isSchoolEmail} from "../../../Utils/converter";
import SchoolEmailVerification from "../../../Component/SchoolEmailVerification/SchoolEmailVerification";
import SubscribedListItem from "../../../Component/SubscribedList/SubscribedListItem/SubscribedListItem";


const db = firebase.firestore()

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isLoadedUserName: false,
            emailVerifying: false,
            profile: {},
            userName: [],
            communityID: [],
            myCommunity: [], //enrolled communityid,
            isLoadedCommunity: false,
            type: '',
            isUpdated: false,
        }

    }

    componentDidMount() {
        if (isAuth(this.props.auth)) {
            this.getProfile(this.props.auth)
            this.getCustomClaim(this.props.auth)
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.auth !== nextProps.auth) {
            if (isAuth(nextProps.auth)) {
                this.getProfile(nextProps.auth)
                this.getCustomClaim(nextProps.auth)
            }
        }
    }

    getCustomClaim = (auth) => {
        if (isAuth(auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then(idTokenResult => {
                    console.log(idTokenResult)
                    if (idTokenResult.claims.hasOwnProperty("userName") && Array.isArray(idTokenResult.claims.userName)) {
                        let newUserName = []
                        idTokenResult.claims.userName.map(e => {
                            newUserName.push(decodeURIComponent(escape(e)))
                        })

                        this.setState({
                            userName: newUserName,
                            type: idTokenResult.claims.hasOwnProperty('type') ? idTokenResult.claims.type : 'normal', //teacher / student / normal
                            communityID: idTokenResult.claims.hasOwnProperty('communityID') ? idTokenResult.claims.communityID : []
                        }, () => {
                            this.getCommunity(this.state.communityID)
                            this.setState({
                                isLoadedUserName: true
                            })
                        })
                    } else {
                        this.setState({
                            userName: [""]
                        }, () => {
                            this.setState({
                                isLoadedUserName: true
                            })
                        })
                    }
                })
        }
    }

    getCommunity = (communityID) => {
        if (Array.isArray(communityID) && communityID.length !== 0) {
            let allPromise = []
            let allCommunity = []
            communityID.map(async (c, index) => {
                allPromise.push(
                    new Promise((resolve, reject) => {
                        db.collection('Community')
                            .doc(c)
                            .get()
                            .then(doc => {

                                if (doc.exists) {
                                    allCommunity.push({
                                        id: doc.id,
                                        ...doc.data()
                                    })
                                    resolve()
                                }
                            })
                            .catch(err => console.log(err))
                    })
                )
            })

            Promise.all(allPromise)
                .then(res => {
                    console.log(allCommunity)
                    this.setState({
                        myCommunity: allCommunity
                    }, () => {
                        this.setState({
                            isLoadedCommunity: true
                        })
                    })
                })

        }
    }

    getProfile = (auth) => {
        db.collection("Member")
            .doc(auth.uid)
            .get()
            .then(doc => {
                    if (doc.exists) {
                        const profile = {
                            id: doc.id,
                            ...doc.data()
                        }

                        this.setState({
                            profile: profile,
                            emailVerifying: profile.pendingEmail !== '' || profile.linkEmail.length !== 0
                        }, () => {
                            this.setState({
                                isLoaded: true
                            })
                        })
                    } else {
                        this.props.history.push('/')
                    }
                }
            )
            .catch(err => console.log(err))
    }

    saveProfile = async () => {
        let userNameList = this.state.userName.filter(e => e !== '')
        return await new Promise((resolve, reject) => {
            fetch("/api/member/update", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    uid: this.props.auth.uid,
                    profile: this.state.profile,
                    userNameList: userNameList
                })
            }).then((res) => res.json()).then((finalResponse) => {
                if (finalResponse.success) {
                    this.setState({
                        isUpdated: true
                    })
                } else {

                }
            })
        })
    }

    addNewName = () => {
        this.setState({
            userName: this.state.userName.concat("")
        })
    }

    setNewUserName = (name, index) => {
        let newList = this.state.userName
        newList[index] = name
        this.setState({
            userName: newList
        })
    }

    removeUserName = (name) => {
        let newList = this.state.userName.filter(el => el !== name)
        this.setState({
            userName: newList
        })
    }


    render() {
        if (this.state.isLoaded && this.state.isLoadedUserName) {
            return (
                <MDBContainer>
                    <MDBRow>
                        <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>
                            <label className={classes.label}>
                                你的身份
                            </label>
                            {
                                !this.state.emailVerifying ?
                                    <SchoolEmailVerification
                                        auth={this.props.auth}
                                    />
                                    : ''
                            }
                            {
                                this.state.profile.hasOwnProperty('pendingEmail') && this.state.profile.pendingEmail !== '' ?
                                    <MDBCard>
                                        <MDBCardBody>
                                            我們正在處理你的申請 <MDBBadge>{this.state.profile.pendingEmail}</MDBBadge>
                                        </MDBCardBody>
                                    </MDBCard>
                                    : ''
                            }

                            {
                                this.state.profile.hasOwnProperty('linkEmail') && this.state.profile.linkEmail !== '' ?
                                    this.state.communityID.length === 0 ?
                                        <MDBCard>
                                            <MDBCardBody>
                                                你的電郵 <MDBBadge>{this.state.profile.linkEmail}</MDBBadge>申請已經批准，請重新登入以使用新設定
                                            </MDBCardBody>
                                        </MDBCard> :
                                        this.state.isLoadedCommunity ?
                                            <MDBListGroup>
                                                {
                                                    this.state.myCommunity.map((e, index) => {
                                                        return (

                                                            <MDBListGroupItem key={'li' + index}
                                                                              className={classes.ListGroupItem}>
                                                                <Link to={'/community/' + e.id}>
                                                                    {e.title}
                                                                </Link>
                                                            </MDBListGroupItem>
                                                        )
                                                    })
                                                }
                                            </MDBListGroup>
                                            : ''
                                    : ''
                            }
                            
                            {/*{*/}
                            {/*    this.state.isLoadedCommunity ?*/}
                            {/*        <MDBListGroup>*/}
                            {/*            {*/}
                            {/*                this.state.myCommunity.map((e, index) => {*/}
                            {/*                    return (*/}
                            
                            {/*                        <MDBListGroupItem key={'li' + index}*/}
                            {/*                                          className={classes.ListGroupItem}>*/}
                            {/*                            <Link to={'/community/' + e.id}>*/}
                            {/*                                {e.title}*/}
                            {/*                            </Link>*/}
                            {/*                        </MDBListGroupItem>*/}
                            {/*                    )*/}
                            {/*                })*/}
                            {/*            }*/}
                            {/*        </MDBListGroup>*/}
                            {/*        : ''*/}
                            {/*}*/}

                            <label className={classes.label}>
                                你的網名
                            </label>
                            <MDBCard className={classes.UserNameContainer}>
                                <MDBListGroup>
                                    {
                                        this.state.userName.map((e, index) => {
                                            return (
                                                <MDBListGroupItem key={index} className={classes.UserNameItem}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled={e === "匿名" }
                                                        onChange={(e) => {

                                                            this.setNewUserName(e.target.value, index)
                                                        }}
                                                        // value={decodeURIComponent(escape(e))}
                                                        value={e}
                                                        placeholder={"你的新身份"}
                                                    />
                                                    {
                                                       e !== "匿名" ?
                                                            <MDBBtn onClick={() => this.removeUserName(e)}
                                                                    color='link'
                                                                    className={classes.RemoveBtn}
                                                                    rounded
                                                            >
                                                                移除
                                                            </MDBBtn>
                                                            : ''
                                                    }

                                                </MDBListGroupItem>
                                            )
                                        })

                                    }
                                </MDBListGroup>
                                <MDBBtn color='secondary'
                                        className={classes.SaveBtn}
                                        onClick={(e) => {
                                            this.addNewName()
                                        }}
                                >
                                    新增
                                </MDBBtn>
                                <MDBBtn color='info'
                                        className={["float-right", classes.SaveBtn].join(' ')}
                                        onClick={(e) => {
                                            this.saveProfile()
                                        }}
                                >
                                    更新
                                </MDBBtn>
                            </MDBCard>

                            {
                                this.state.isUpdated ?
                                    <MDBAlert>
                                        你需要重新登入以更新資料
                                    </MDBAlert>
                                    : ''
                            }
                        </MDBCol>

                    </MDBRow>

                </MDBContainer>
            );
        } else {
            return (
                <div>
                    loading...
                </div>
            )
        }

    }

}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(Profile))